var req = require("!!/app/node_modules/pug-loader/index.js??ref--13-1!/app/src/app/event-external-root/event-external-root.pug");
module.exports = (req['default'] || req).apply(req, [])